/**
 * Takes a user first and last name and shortens it.
 *
 * For example "Josh Nice" -> "Josh N."
 *
 * If either first name or last name is null, it will just return the other name.
 */
export const shortenName = (firstName: string | null, lastName: string | null, fallbackName: string) => {
    if (lastName == null && firstName == null) {
        return fallbackName;
    }

    if (firstName == null || firstName.length === 0) {
        return lastName;
    }

    if (lastName == null || lastName.length === 0) {
        return firstName;
    }

    return `${firstName} ${lastName[0]}.`;
};
